// we don't need jQuery in WordPress install because it will be included already in the app.
// make sure we won't load jQuery in multiple files
// import 'jquery'
// import main loader
import 'system/loader'
// load app
import App from 'system/app'

// init
var app = new App()
window.App = app



/** WEBPACK FOOTER **
 ** ./main.js
 **/